module.exports = __webpack_public_path__ + "img/WEBSITE-LOGO-copy-1-711x400.0b63a48c.jpg";